﻿import React, { useState, useEffect } from 'react';
import { BatchListItem } from '../models/batch-list-item';
import { LookupItem } from '../models/lookup-item';
import { CrudFunctions } from '../utilities/crud-functions';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';
import GlobalDialog from './Modal/GlobalDialog';

import { NumberBox } from 'devextreme-react/number-box';
import { SelectBox } from 'devextreme-react/select-box';
import { Button } from 'devextreme-react/button';

export interface Props {
    productId: string;
    copyBatch: boolean;
    selectedBatch?: BatchListItem;
    onClose?: () => void;
}

export default function AddBatchComponent(props: Props) {
    const [newBatch, setNewBatch] =
        useState<BatchListItem>();

    const [batchTypes, setBatchTypes] =
        useState<LookupItem[]>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    useEffect(() => {
        getBatchTypes();
        createNewBatch();
    }, []);

    useEffect(() => {
        getNewBatchVersionNumber();
    }, [props.selectedBatch]);

    return (
        <div>
            {props.copyBatch &&
                <div className="pw-form-unit">
                    <div className="pw-form-unit-label">Source Batch Name</div>
                    <div className="pw-readonly-label">{props.selectedBatch ? props.selectedBatch.batchName : ''}</div>
                </div>
            }

            <div className="pw-form-unit">
                <div className="pw-form-unit-label">Batch Version</div>
                <NumberBox id="batchVersion"
                    className="textbox"
                    onValueChanged={onPropertyChanged}
                    placeholder="batch version" value={newBatch ? newBatch.batchVersion : undefined} />
            </div>

            <div className="pw-form-unit">
                <div className="pw-form-unit-label">Batch Type</div>
                <SelectBox id="batchType" className="selectbox"
                    placeholder='batch type'
                    displayExpr='description' valueExpr='id'
                    dataSource={batchTypes ? batchTypes : []}
                    value={newBatch && newBatch.batchType ? newBatch.batchType : undefined}
                    onValueChanged={onPropertyChanged} />
            </div>

            <div className="pw-comp-row">
                <div className="pw-centered-buttons-container">
                    <Button type="success" id="addNewBatchDialogSaveButton" className="pw-button" onClick={addNewBatch} text="Save" />
                    <Button className="pw-button" id="addNewBatchDialogCancelButton" onClick={hideNewBatchPrompt} text="Cancel" />
                </div>
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }
        </div>
    );

    function onPropertyChanged(e: any) {
        if (e.element && e.element.id) {
            const caller = e.element.id;

            setNewBatch({ ...newBatch, [caller]: e.value });
        }
    }

    async function addNewBatch() {
        if (props.productId && newBatch) {
            if (!newBatch.batchType) {
                showInformationMessage(ModalMessageType.Warning, "Missing Batch Type", "A batch type is required");
                return;
            }

            /*
            if (props.selectedBatch) {
              copyBatch(props.selectedBatch.batchId, newBatch.batchName)
                            .then((data) => {
                                
                                //setCopyBatchSourceBatchId(null);
                                
                                //if (data.value) {
                                //    setNewBatchId(data.value);
                                //    setRedirectToNewBatch(true);
                                //}
                                

                            })
                            .catch((res) => {
                                showMessage(res, ModalMessageType.Error, "Error Copying Batch");
                            });
                    }
                    else {
                    */

            saveNewBatch(newBatch)
                .then((data) => {
                    hideNewBatchPrompt();

                    /*
                    if (data.name && data.value) {
                        setNewBatchId(data.value);
                        setRedirectToNewBatch(true);
                    }
                    */
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Saving New Batch");
                });
        }
    }

    async function saveNewBatch(batch: BatchListItem) {
        return CrudFunctions.postData(`products/batch/${props.productId}`, batch);
    }

    //need to send batchName in body so CrudFunction will return result
    async function copyBatch(sourceBatchId: string, batchName: string) {
        return CrudFunctions.postData(`batches/copybatch/${sourceBatchId}/${batchName}`, batchName);
    }

    function hideNewBatchPrompt() {
        if (props.onClose)
            props.onClose();
    }

    function createNewBatch() {
        let batch: BatchListItem = { };

        if (!props.copyBatch)
            batch.batchVersion = 1;

        setNewBatch(batch);
    }

    async function getBatchTypes() {
        await CrudFunctions.getData("common/batchtypes")
            .then((data) => {
                setBatchTypes(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Batch Types");
            });
    }

    async function getNewBatchVersionNumber() {
        if (props.selectedBatch && props.selectedBatch.batchName) {
            await CrudFunctions.getData(`products/nextbatchversionnumber/${props.selectedBatch.batchName}`)
                .then((data) => {
                    console.log("NEXT batch#");
                    console.log(data);

                    if (data && data.value)
                        setNewBatch({ ...newBatch, batchVersion: data.value });
                    else
                        showInformationMessage(ModalMessageType.Warning, "Next Batch Version", "The next batch version could not be retrieved.");
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Next Batch Number");
                });
        }
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function showInformationMessage(mode: ModalMessageType, title: string, message: string) {
        let mm: ModalMetadata = {
            error: null,
            mode: mode,
            title: title,
            message: message
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

}
